import { FC, ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useCurrentUser } from "hooks";

interface RestrictedRouteProps {
  children: ReactElement;
  restrictedRoles?: string[];
  redirectTo?: string;
}

/**
 * Generic route wrapper that restricts access based on user roles
 * By default, restricts access for Driver role users
 * Redirects restricted users to the specified path (default: /dashboard)
 */
const RestrictedRoute: FC<RestrictedRouteProps> = ({
  children,
  restrictedRoles = ["Driver"],
  redirectTo = "/dashboard"
}) => {
  const { currentRoleName, isDriver } = useCurrentUser();

  // Check if current role is in the restricted list
  const isRestricted = restrictedRoles.some((role) => {
    if (role === "Driver") return isDriver;
    return currentRoleName === role;
  });

  // If user has a restricted role, redirect
  if (isRestricted) {
    return <Navigate to={redirectTo} replace />;
  }

  // Otherwise, render the protected content
  return children;
};

export default RestrictedRoute;
